var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      class: _vm.className,
      attrs: {
        value: _vm.value,
        disabled: _vm.disabled,
        size: _vm.size,
        clearable: _vm.clearable,
        placeholder: _vm.placeholder,
        filterable: _vm.filterable,
        remote: _vm.remote,
        multiple: _vm.multiple,
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading,
      },
      on: { change: _vm.change },
    },
    _vm._l(_vm.dataList, function (item) {
      return _c("el-option", {
        key: item[_vm.propKey.key],
        attrs: {
          label: item[_vm.propKey.label],
          value: item[_vm.propKey.value],
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/filter/defaultSelect.vue?vue&type=template&id=5234a556&
// module id = null
// module chunks = 